<template>
  <div id="app">
    <v-app>
      <router-view />
    </v-app>
  </div>
</template>

<script>
import router from './router'
import { mapState } from 'vuex'

export default {
  data: () => ({

  }),
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.isLoggedIn
    })
  },
  created() {
    if (this.isLoggedIn) {
      router.push('/dashboard');
    } else {
      if (this.$route.query.hasOwnProperty('result')) {
        console.log(this.$route.query.result);
      } else {
        router.push('/login');
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Kanit', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
